import { useCallback, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Router from '../constants/router';
// @ts-ignore
import usePersistedState from './usePersistedState';

export function useRedirectEffect(): void {
  const { path: prevPath, clear } = usePrevPath();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!prevPath || pathname === prevPath) {
      return;
    }
    clear();
    Router.navigate(prevPath);
  }, [prevPath]);
}

export function useRedirect(): (url: string) => void {
  const { savePath } = usePrevPath();

  return useCallback((url: string) => {
    savePath();
    window.open(url, '_blank');
  }, [savePath]);
}

interface UsePrevPathReturn {
  path: string | null;
  clear: () => void;
  savePath: () => void;
}

function usePrevPath(): UsePrevPathReturn {
  const { pathname } = useLocation();
  const [path, setPath] = usePersistedState<string | null>(null, {
    key: 'use-prev-path/path',
    ttl: 1000 * 60,
  });

  return useMemo(() => ({
    path,
    clear: () => setPath(null),
    savePath: () => setPath(pathname),
  }), [pathname, path]);
}
